import React from 'react';

interface StackNavigatorViewProps {
  id: string;
  children: React.ReactElement;
  navigation?: unknown;
}

const StackNavigatorView = ({ id, navigation = {}, children }: StackNavigatorViewProps) => {
  if (navigation.pathname === id) {
    return children;
  }

  return null;
};

export default StackNavigatorView;
